import React from "react";
import { useSelector } from "react-redux";

export default function Billdetails({ CartProducts }) {
  const cartItems = useSelector((state) => state.cart);
  const subTotal = CartProducts.reduce((prevPrice, currentItem) => {
    const index = cartItems.findIndex((itm) => itm.id === currentItem.id);
    return prevPrice + currentItem.price * cartItems[index].quantity;
  }, 0);
  const vat = 0;
  const discount = 0;
  return (
    <div>
      <div className="billDetailsCard">
        <h4 className="mt-2 mb-8 text-xl font-bold text-center">
          Bill Details
        </h4>
        <div className="space-y-4">
          <div className="flex items-center justify-between">
            <p>Sub Total</p>
            <p>
              BDT <span className="lws-subtotal">{subTotal}</span>
            </p>
          </div>
          <div className="flex items-center justify-between">
            <p>Discount</p>
            <p>
              BDT <span className="lws-discount">{discount}</span>
            </p>
          </div>
          <div className="flex items-center justify-between">
            <p>VAT</p>
            <p>
              BDT <span className="vat">{vat}</span>
            </p>
          </div>
          <div className="flex items-center justify-between pb-4">
            <p className="font-bold">TOTAL</p>
            <p className="font-bold">
              BDT <span className="lws-total">{subTotal + discount - vat}</span>
            </p>
          </div>
          <button className="placeOrderbtn">place order</button>
        </div>
      </div>
    </div>
  );
}
